/**
 * Tipos e chamadas dos três parâmetros de "Catálogo" — grade de tamanhos,
 * paleta de cores e o padrão de estoque mínimo aplicado a SKU novo.
 *
 * O contrato espelha `api/internal/modulos/conta/catalogo.go`. Os três moram
 * na tela de Configurações > Parâmetros da loja (`TelaConfiguracoes.tsx`,
 * função `grupoLoja`).
 */
import { api } from './api'

export type Grade = {
  roupas: string[]
  numeracoes: string[]
}

export type PedidoGrade = Grade

export function buscarGrade(sinal?: AbortSignal): Promise<Grade> {
  return api.get<Grade>('/catalogo/grade', sinal)
}

export function salvarGrade(pedido: PedidoGrade): Promise<Grade> {
  return api.put<Grade>('/catalogo/grade', pedido)
}

export type Cor = {
  nome: string
  /** `#RRGGBB`. Ausente quando a cor não tem amostra visual definida. */
  hex?: string
}

export type Cores = {
  cores: Cor[]
}

export type PedidoCores = Cores

export function buscarCores(sinal?: AbortSignal): Promise<Cores> {
  return api.get<Cores>('/catalogo/cores', sinal)
}

export function salvarCores(pedido: PedidoCores): Promise<Cores> {
  return api.put<Cores>('/catalogo/cores', pedido)
}

export type ConfiguracaoCatalogo = {
  /**
   * O mínimo aplicado a SKU NOVO. Mudar este número não retroage nos SKUs já
   * cadastrados — cada um continua com o próprio mínimo, ajustável no
   * cadastro de produto.
   */
  estoque_minimo_padrao: number
}

export type PedidoConfiguracaoCatalogo = ConfiguracaoCatalogo

export function buscarConfiguracaoCatalogo(sinal?: AbortSignal): Promise<ConfiguracaoCatalogo> {
  return api.get<ConfiguracaoCatalogo>('/catalogo/configuracao', sinal)
}

export function salvarConfiguracaoCatalogo(pedido: PedidoConfiguracaoCatalogo): Promise<ConfiguracaoCatalogo> {
  return api.put<ConfiguracaoCatalogo>('/catalogo/configuracao', pedido)
}
